import { PageModel } from "./PageModel";

class TemplateProjectsController extends PageModel {

}

export { TemplateProjectsController }
